import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styles from "./styles.scss";
import { actions, getters } from "../model";
import {
  actions as MainActions,
  getters as MainGetters
} from "Portal/NewPortal/Sections/Sessions/FlyOver/model";
import Loading from "ui-kit/Loading";
import CollapsablePanel from "ui-kit/CollapsiblePanel";
import { Div, Text2, Text3, MediumAvatar } from "components/Base";
import * as R from "ramda";
import { noop } from "utils/General";
import ViewContact from "./ViewContact";
import { getIsManageSessionsEnabled } from "Portal/NewPortal/PortalHome/selectors";
const renderPeopleList = (
  title,
  items,
  sessionId,
  expanded,
  onClick,
  onParticipantClick,
  isManageSessionsEnabled
) =>
  R.not(R.isEmpty(items)) ? (
    <CollapsablePanel
      arrowColor="#666666"
      isArrowVisible={true}
      right={true}
      heading={
        <Text3 bold width={1} color="#343434" p={0}>
          {title} ({items.length})
        </Text3>
      }
      bg="white"
      p={0}
      px={2.5}
      arrowSizeWFS={4}
      opened={expanded}
      onClick={onClick}
      className={styles.collapsablePanel}
    >
      <Div display="column.flex-start.stretch">
        {R.map(participant => {
          return (
            <Div
              mt={1.5}
              key={`session-${sessionId}-speaker-${participant.id}`}
              className={styles.card}
              p={3}
              display="row.flex-start.stretch"
              style={{
                cursor: isManageSessionsEnabled ? "pointer" : "default"
              }}
              onClick={() => onParticipantClick(participant)}
            >
              <Div display="column.flex-start.flex-start">
                <MediumAvatar
                  longInitials
                  size={40}
                  style={{
                    height: 40,
                    width: 40,
                    borderRadius: 4
                  }}
                  id={participant.id}
                  name={participant.name}
                  photoURL={participant.photo_url}
                />
              </Div>
              <Div display="column.justify-content.flex-start">
                <Text3 bold>{participant.name}</Text3>
                {participant.title ? <Text2>{participant.title}</Text2> : null}
                {participant.company ? (
                  <Text2>{participant.company}</Text2>
                ) : null}
              </Div>
            </Div>
          );
        }, items)}
      </Div>
    </CollapsablePanel>
  ) : null;

const decorate = connect(
  state => ({
    sessionData: MainGetters.sessionData(state),
    chairpersons: getters.chairpersons(state),
    speakers: getters.speakers(state),
    sponsors: getters.sponsors(state),
    moderators: getters.moderators(state),
    exhibitors: getters.exhibitors(state),
    loading: getters.loading(state),
    contactDataInUse: MainGetters.contactDataInUse(state),
    isManageSessionsEnabled: getIsManageSessionsEnabled(state)
  }),
  {
    init: actions.init,
    setContactDataInUse: MainActions.setContactDataInUse,
    setContactData: actions.setContactData,
    setEditedContactData: actions.setEditedContactData,
    selectParticipant: actions.selectParticipant
  }
);

const Participants = ({
  loading = true,
  sessionData,
  init,
  speakers = [],
  chairpersons = [],
  moderators = [],
  sponsors = [],
  exhibitors = [],
  setContactDataInUse = noop,
  setContactData = noop,
  setEditedContactData = noop,
  contactDataInUse = {},
  selectParticipant,
  isManageSessionsEnabled
}) => {
  if (!R.isEmpty(contactDataInUse)) {
    const closeView = () => {
      setContactDataInUse({});
    };
    return <ViewContact data={contactDataInUse} closeView={closeView} />;
  }

  const [speakersExpanded, setSpeakersExpanded] = useState(false);
  const [chairpersonsExpanded, setChairpersonsExpanded] = useState(false);
  const [moderatorsExpanded, setModeratorsExpanded] = useState(false);
  const [sponsorsExpanded, setSponsorsExpanded] = useState(false);
  const [exhibitorsExpanded, setExhibitorsExpanded] = useState(false);
  const onContactClick = data => {
    selectParticipant({ contactId: data.id });
    setContactDataInUse(data);
    setContactData(data);
    setEditedContactData(data);
  };
  const onAccountClick = data => {
    selectParticipant({ accountId: data.id });
    setContactDataInUse(data);
    setContactData(data);
    setEditedContactData(data);
  };

  useEffect(() => {
    const { id: sessionId } = sessionData;
    init({ sessionId, viaPortal: true });
  }, []);

  const toggleExpanded = type => {
    switch (type) {
      case "speakers":
        setSpeakersExpanded(!speakersExpanded);
        break;
      case "chairpersons":
        setChairpersonsExpanded(!chairpersonsExpanded);
        break;
      case "moderators":
        setModeratorsExpanded(!moderatorsExpanded);
        break;
      case "sponsors":
        setSponsorsExpanded(!sponsorsExpanded);
        break;
      case "exhibitors":
        setExhibitorsExpanded(!exhibitorsExpanded);
        break;
      default:
        break;
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={styles.container}>
      <Div className={styles.section} display="column.flex-start.stretch">
        {renderPeopleList(
          "Speakers",
          speakers,
          sessionData?.id,
          speakersExpanded,
          () => toggleExpanded("speakers"),
          isManageSessionsEnabled ? onContactClick : noop,
          isManageSessionsEnabled
        )}
        {renderPeopleList(
          "Chairpersons",
          chairpersons,
          sessionData?.id,
          chairpersonsExpanded,
          () => toggleExpanded("chairpersons"),
          isManageSessionsEnabled ? onContactClick : noop,
          isManageSessionsEnabled
        )}
        {renderPeopleList(
          "Moderators",
          moderators,
          sessionData?.id,
          moderatorsExpanded,
          () => toggleExpanded("moderators"),
          isManageSessionsEnabled ? onContactClick : noop,
          isManageSessionsEnabled
        )}
        {renderPeopleList(
          "Sponsors",
          sponsors,
          sessionData?.id,
          sponsorsExpanded,
          () => toggleExpanded("sponsors"),
          isManageSessionsEnabled ? onAccountClick : noop,
          isManageSessionsEnabled
        )}
        {renderPeopleList(
          "Exhibitors",
          exhibitors,
          sessionData?.id,
          exhibitorsExpanded,
          () => toggleExpanded("exhibitors"),
          isManageSessionsEnabled ? onAccountClick : noop,
          isManageSessionsEnabled
        )}
      </Div>
    </div>
  );
};

export default decorate(Participants);
